<template>
  <div class="conter">
    <button @click="translationStart" v-if="vS">开始</button>
    <button @click="translationEnd" v-else>停止</button>
  </div>
</template>
<script>
import IatRecorder from "@/common/IatRecorder";
// const iatRecorder = new IatRecorder("zh_cn", "mandarin", "5ff2d877"); //小语种-中文方言-appId
export default {
  data() {
    return {
      vS: true,
      iatRecorder: null,
      voiceText: "",
    };
  },
  methods: {
    translationStart() {
      this.voiceText = "";
      this.vS = false;
      this.iatRecorder.start(this.cancel, this.getVoiceText);
    },
    translationEnd() {
      this.iatRecorder.onTextChange = (text) => {
        let inputText = text;
        var searchData = inputText.substring(0, inputText.length - 1); //文字处理，因为不知道为什么识别输出的后面都带‘。’，这个方法是去除字符串最后一位
        this.getVoiceText(text);
        // console.log(searchData);
      };
      this.iatRecorder.stop();
      this.vS = true;
    },
    getVoiceText(text) {
      //   this.voiceText = text.substring(0, inputText.length - 1);
      this.voiceText = text.split("。")[0];
      if (this.voiceText == "") {
        return;
      }
      console.log(this.voiceText);
    },
    cancel() {
      this.vS = true;
    },
  },
  mounted() {
    //   this.iatRecorder = iatRecorder
    this.iatRecorder = new IatRecorder("zh_cn", "mandarin", "5ff2d877"); //小语种-中文方言-appId
  },
};
</script>


// WEBPACK FOOTER //
// src/components/voiceDemo.vue